export default __webpack_public_path__ + "media/images/home/slide_2week_private_room_sm-ff0d6f75785a61ee4cdd19388b8be85c.jpg";